<p-panel [toggleable]="true">
  <ng-template pTemplate="header">
    <div class="filter-card-header">
      <span class="filter-icon"><i class="fa fa-download"></i></span>
      <span class="filter-card-title">Export comparison report (Excel)</span>
    </div>
  </ng-template>
  <div class="filter-fields">
    <div class="filter-field">
      <p-floatLabel>
        <p-multiSelect [(ngModel)]="selectedClients" [options]="uniqCompanyItems" appendTo="body" inputId="comparisonClients"
                       name="uniqCompanyItems" panelStyleClass="portal-overlay" required></p-multiSelect>
        <label for="comparisonClients">Clients</label>
      </p-floatLabel>
    </div>
    <div class="filter-field filter-field--month">
      <p-floatLabel>
        <p-calendar [(ngModel)]="dateFilterFrom" appendTo="body" dateFormat="mm/yy" inputId="comparisonFrom" name="dateFilterFrom"
                    panelStyleClass="portal-datepicker" required view="month"></p-calendar>
        <label for="comparisonFrom">From</label>
      </p-floatLabel>
    </div>
    <div class="filter-field filter-field--month">
      <p-floatLabel>
        <p-calendar [(ngModel)]="dateFilterTo" appendTo="body" dateFormat="mm/yy" inputId="comparisonTo" name="dateFilterTo"
                    panelStyleClass="portal-datepicker" required view="month"></p-calendar>
        <label for="comparisonTo">To</label>
      </p-floatLabel>
    </div>
    <div class="filter-field">
      <p-floatLabel>
        <p-multiSelect [(ngModel)]="selectedExchanges" [filter]="false" [options]="uniqExchangeItems" appendTo="body"
                       inputId="comparisonExchanges" maxSelectedLabels="2" name="selectedExchanges"
                       panelStyleClass="portal-overlay" required></p-multiSelect>
        <label for="comparisonExchanges">Exchange</label>
      </p-floatLabel>
    </div>
    <div class="filter-actions">
      <button (click)="exportReport()" [disabled]="selectedExchanges.length < 1 || selectedClients.length < 1" class="primary-btn" type="button">
        <i aria-hidden="true" class="fa fa-download"></i>
        Export
      </button>
    </div>
  </div>
</p-panel>
